
export default (https) => ({

  

  async add(payload) {
    const response = await https.post(`/adjustments`, payload);
    return response.data;
  },
  async bulkAdd(payload) {
    const response = await https.post(`/adjustments/bulk`, payload);
    return response.data;
  },
  
});
